import React from "react";

import { CssBaseline } from "@mui/material";
import { createTheme, StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LicenseInfo } from "@mui/x-license";
import { ConfirmProvider } from "material-ui-confirm";




const Warehouse = () => {
  const MUI_KEY =
    "68b8ce98a3b3cf407c204e497a3011f8Tz0xMDc2MjYsRT0xNzcwODU0Mzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y";
  LicenseInfo.setLicenseKey(MUI_KEY);
  const muiTheme = createTheme();

  return (
    <React.StrictMode>
        <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="en-us">
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={muiTheme}>
              <CssBaseline />
              <ConfirmProvider>
                {
                  'Router GOES HERE'
                }
              </ConfirmProvider>
            </ThemeProvider>
          </StyledEngineProvider>
        </LocalizationProvider>
    </React.StrictMode>
  );
};

export default Warehouse;
